import React, { createContext, useContext, useReducer } from "react";

import SectionHeader from "@cayuse/shared-react.components.section-header";

import BasePadding from "@cayuse/shared-react.components.base-padding";

import { OverviewSubawards } from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewSubawards";
import { OverviewTotalDirectCosts } from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewTotalDirectCosts";
import Table from "components/Table";

import { OverviewExternalCostShare } from "./OverviewExternalCostShare";
import { OverviewFAItems } from "./OverviewFAItems";
import { OverviewInternalCostShare } from "./OverviewInternalCostShare";
import { OverviewResearchTeam } from "./OverviewResearchTeam";
import { OverviewSponsoredCosts } from "./OverviewSponsoredCosts";
import { OverviewTableHeader } from "./OverviewTableHeader";
import { OverviewTotalCosts } from "./OverviewTotalCosts";
import { OverviewTotalCostShare } from "./OverviewTotalCostShare";
import { OverviewTotalSponsorCosts } from "./OverviewTotalSponsorCosts";


function isExpandedReducer (state, action) {
	switch (action.type) {
	case "setAllIsExpanded":
		let newState = {};
		for (let key in state) {
			newState[key] = action.isExpanded;
		}

		return newState;
	default:
		return {
			...state,
			[action.type]: action.isExpanded,
		};
	}
}

const IsExpandedContext = createContext({});

export const useIsExpandedContext = () => useContext(IsExpandedContext);

const OverviewLineItemsList = () => {
	const [ isExpandedState, isExpandedDispatch ] = useReducer(isExpandedReducer, {});

	return (
		<>
			<SectionHeader
				header={"Summary of All Budget Items and Periods"}
				breadcrumbs={<span>{"Values displayed here may be edited and adjusted in subsequent tabs"}</span>}
			/>
			<BasePadding>
				<IsExpandedContext.Provider value={{ isExpandedState, isExpandedDispatch }}>
					<Table captionText="Summary of All Budget Items and Periods">
						<OverviewTableHeader />
						<Table.Body>
							<OverviewResearchTeam />
							<OverviewSponsoredCosts />
							<OverviewSubawards />
							<OverviewTotalDirectCosts />
							<OverviewFAItems />
							<OverviewTotalSponsorCosts />
							<OverviewInternalCostShare />
							<OverviewExternalCostShare />
							<OverviewTotalCostShare />
							<OverviewTotalCosts />
						</Table.Body>
					</Table>
				</IsExpandedContext.Provider>
			</BasePadding>
		</>
	);
};

export default OverviewLineItemsList;
